import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MonthlyOverviewComponent } from './monthly-overview.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, TranslateModule],
  exports: [MonthlyOverviewComponent],
  declarations: [MonthlyOverviewComponent],
})
export class MonthlyOverviewModule {}
